var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 105,
    viewBox: "0 0 17 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 99.5301,
    fill: "#5B94EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 100,
    width: 3,
    height: 11,
    transform: "rotate(-90 0 100)",
    fill: "#5B94EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2595 97.6243L7.14611 103.431L7.05866 91.9573L16.2595 97.6243Z",
    fill: "#5B94EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrowIcon);
export default __webpack_public_path__ + "static/media/linkArrowIcon.0f60be14199d30ab9d07100c10b9a6af.svg";
export { ForwardRef as ReactComponent };